<template>
    <div>
        <div>
            <b-row no-gutters>
                <b-col sm="6" md="8">
                    <EngagementNav></EngagementNav>
                </b-col>
                <b-col sm="6" md="4" style="background-color: #ffffff">
                    <div id="my-wallet-wrapper" class="py-3 mx-auto my-3">
                        <b-row no-gutters>
                            <b-col cols="3">
                                <div class="text-center py-2 pl-1">
                                    <span id="my-wallet-label">My Wallet</span>
                                </div>
                            </b-col>
                            <b-col>
                                <div class="d-inline-block">
                                    <div id="my-wallet" class="py-1 border">
                                        <b-row no-gutters>
                                            <b-col cols="2" class="text-right">
                                                <span style="color: #f46d00; font-family: MainFontBold, sans-serif; font-weight: normal; font-size: 22px">
                                                    &#8369;
                                                </span>
                                            </b-col>
                                            <b-col>
                                                <b-form-input
                                                        id="my-wallet-input"
                                                        type="text"
                                                        placeholder="N/A"
                                                        class="text-center"
                                                        size="sm"
                                                >
                                                </b-form-input>
                                            </b-col>
                                            <b-col cols="2">
                                                <div id="button-wrapper">
                                                    <b-button variant="primary" class="rounded-circle">
                                                        +
                                                    </b-button>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                                <i id="my-wallet-help" class="d-inline-block"></i>
                                <b-popover target="my-wallet-help"
                                           triggers="hover"
                                           placement="bottomleft"
                                           content="Set your budget that can be used for Facebook Ad campaign.">
                                </b-popover>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div>
            <div class="engagement-body">
                <div class="engagement-content">
                    <b-row>
                        <b-col sm="6" md="3">
                            <b-input-group>
                                <b-input-group slot="append">
                                    <i class="icon-calendar"></i>
                                </b-input-group>
                                <datepicker
                                    :config="daterangeConfig">
                                </datepicker>
                            </b-input-group>
                        </b-col>
                        <b-col sm="6" md="3">
                            <div class="filter-wrapper">
                                <b-input-group prepend=" ">
                                    <b-form-input placeholder="Search"></b-form-input>
                                    <b-dropdown text="Advanced" variant="primary" slot="append">
                                        <b-dropdown-item>Action A</b-dropdown-item>
                                        <b-dropdown-item>Action B</b-dropdown-item>
                                    </b-dropdown>
                                </b-input-group>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col>
                            <div class="filter-wrapper">
                                <b-form inline>
                                    <label class="mr-sm-2 muli-b" for="inlineFormAdAccount">Ad Account:</label>
                                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0 custom-select ml-1"
                                                    :value="1"
                                                    :options="{ '2': 'Sample 2 Section', '3': 'Sample 3 Section' }"
                                                    id="inlineFormAdAccount">
                                        <option slot="first" :value="1">RUSH Section</option>
                                    </b-form-select>
                                    <b-button variant="primary" class="new-button ml-2" @click="showModal('addFacebookAd')">+ Add Facebook Ad</b-button>
                                </b-form>
                            </div>
                            <b-modal id="addFacebookAd" title="Add Facebook Ad" v-bind:class="{ 'extra-large-modal': tabIndex != 0 }">
                                <div id="add-facebook-ad-container" class="modal-form">
                                    <h2 class="text-center" v-bind:class="{ 'd-block': tabIndex === 0, 'd-none': tabIndex != 0 }"><span>Step 1:</span> Ad Adwork</h2>
                                    <h2 class="text-center" v-bind:class="{ 'd-block': tabIndex === 1, 'd-none': tabIndex != 1 }"><span>Step 2:</span> Ad Set</h2>
                                    <h2 class="text-center" v-bind:class="{ 'd-block': tabIndex === 2, 'd-none': tabIndex != 2 }"><span>Step 3:</span> Ad Creative</h2>
                                    <section id="stepper-wrapper" class="mx-auto mb-5">
                                        <ol class="stepper">
                                            <li v-bind:class="{ 'is-active': tabIndex === 0, 'is-complete': tabIndex > 0 }"><span></span></li>  
                                            <li v-bind:class="{ 'is-active': tabIndex === 1, 'is-complete': tabIndex > 1 }"><span></span></li>  
                                            <li v-bind:class="{ 'is-active': tabIndex === 2, 'is-complete': tabIndex > 2 }"><span></span></li>
                                        </ol>
                                    </section>
                                    <b-tabs v-model="tabIndex">
                                        <b-tab title="Ad Adwork">
                                            <b-form-group id="objectiveGroup"
                                                        label="Objective <i id='objective-label-help' class='help d-inline-block'></i>"
                                                        label-for="objective" class="secondary-label">
                                                <b-popover target="objective-label-help"
                                                        triggers="hover"
                                                        content="This is the desired end result of this Facebook Ad campaign.">
                                                </b-popover>
                                                <b-form-select id="objective"
                                                            v-model="form.selectedObjective" 
                                                            :options="form.objectiveOptions" 
                                                            class="mb-3 muli-sb" />
                                            </b-form-group>
                                            <b-form-group id="adNameGroup"
                                                        label="Ad Name <i id='ad-name-help' class='help d-inline-block'></i>"
                                                        label-for="adName" class="secondary-label">
                                                <b-popover target="ad-name-help"
                                                        triggers="hover"
                                                        content="This is the name of the advertising material that will be published as a Facebook Ad.">
                                                </b-popover>
                                                <b-form-input id="adName"
                                                              type="text"
                                                              v-model="form.adName"
                                                              placeholder="Enter ad name"
                                                              required>
                                                </b-form-input>
                                            </b-form-group>
                                        </b-tab>
                                        <b-tab title="Ad Set" class="ad-set">
                                            <b-row>
                                                <b-col cols="7">
                                                    <b-row no-gutters>
                                                        <b-col sm="12" md="4">
                                                            <h6 class="main-label">Audience<i id="audience-label-help" class="help d-inline-block"></i></h6>
                                                            <b-popover target="audience-label-help"
                                                                    triggers="hover"
                                                                    content="These are the potential recepients of the advertising material.">
                                                            </b-popover>
                                                        </b-col>
                                                        <b-col>
                                                            <b-form-group id="categoryGroup"
                                                                        label="Select Category"
                                                                        label-for="category" class="secondary-label">
                                                                <b-form-select id="objective"
                                                                            v-model="form.selectedCategory" 
                                                                            :options="form.categoryOptions"
                                                                            class="mb-3 muli-sb" />
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row no-gutters>
                                                        <b-col sm="12" md="4">
                                                            <h6 class="main-label">Daily Budget<i id="daily-budget-label-help" class="help d-inline-block"></i></h6>
                                                            <b-popover target="daily-budget-label-help"
                                                                    triggers="hover"
                                                                    content="Nominate the budget per day of this campaign.">
                                                            </b-popover>
                                                        </b-col>
                                                        <b-col>
                                                            <b-form-group id="daily-budget-group"
                                                                        label="Enter Amount"
                                                                        label-for="dailyBudget" class="secondary-label">
                                                                <b-form-input id="dailyBudget"
                                                                              type="text"
                                                                              v-model="form.dailyBudget"
                                                                              placeholder="0.00"
                                                                              required>
                                                                </b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                        <b-col>
                                                            <hr class="form-divider">
                                                        </b-col>
                                                    </b-row>
                                                    <b-row no-gutters>
                                                        <b-col sm="12" md="4">
                                                            <h6 class="main-label">Start Schedule<i id="start-schedule-label-help" class="help d-inline-block"></i></h6>
                                                            <b-popover target="start-schedule-label-help"
                                                                    triggers="hover"
                                                                    content="This is the date that the Facebook Ad will be active.">
                                                            </b-popover>
                                                        </b-col>
                                                        <b-col>
                                                            <b-row no-gutters>
                                                                <b-col>
                                                                    <b-form-group class="mb-1">
                                                                        <label class="secondary-label align-top">Date</label>
                                                                        <div class="custom-datepicker mb-3 muli-sb">
                                                                            <SingleDatepicker :bootstrap-styling="true"
                                                                                            :value="form.date"
                                                                                            ref="programaticOpen"
                                                                                            v-model="form.date"
                                                                                            wrapper-class="custom-datepicker"
                                                                                            style="color: #2a2a2a !important;"
                                                                            >
                                                                                <div slot="afterDateInput" class="input-group-append pr-0">
                                                                                    <span class="input-group-text">
                                                                                        <img @click="openPicker" src="../../assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button">
                                                                                    </span>
                                                                                </div>
                                                                            </SingleDatepicker>
                                                                        </div>
                                                                    </b-form-group>
                                                                </b-col>
                                                                <b-col>
                                                                    <div id="custom-timepicker" style="width: 164px;">
                                                                        <b-form-group class="ml-3">
                                                                            <label class="secondary-label align-top">Time</label>
                                                                            <b-input-group>
                                                                                <b-input-group-text slot="append">
                                                                                    <img src="../../assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                                                                                </b-input-group-text>
                                                                                <vue-timepicker v-model="scheduledTime" format="HH:mm:ss" hide-clear-button></vue-timepicker>
                                                                            </b-input-group>
                                                                        </b-form-group>
                                                                    </div>
                                                                </b-col>
                                                            </b-row>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row class="mb-2">
                                                        <b-col>
                                                            <hr class="form-divider">
                                                        </b-col>
                                                    </b-row>
                                                    <b-row no-gutters>
                                                        <b-col sm="12" md="4">
                                                            <h6 class="main-label">End Schedule<i id="end-schedule-label-help" class="help d-inline-block"></i></h6>
                                                            <b-popover target="end-schedule-label-help"
                                                                    triggers="hover"
                                                                    content="This is the date that the Facebook Ad will be deactivated.">
                                                            </b-popover>
                                                        </b-col>
                                                        <b-col>
                                                            <b-row no-gutters>
                                                                <b-col>
                                                                    <b-form-group class="mb-1">
                                                                        <label class="secondary-label align-top">Date</label>
                                                                        <div class="custom-datepicker mb-3 muli-sb">
                                                                            <SingleDatepicker :bootstrap-styling="true"
                                                                                            :value="form.date"
                                                                                            ref="programaticOpen"
                                                                                            v-model="form.date"
                                                                                            wrapper-class="custom-datepicker"
                                                                                            style="color: #2a2a2a !important;"
                                                                            >
                                                                                <div slot="afterDateInput" class="input-group-append pr-0">
                                                                                    <span class="input-group-text">
                                                                                        <img @click="openPicker" src="../../assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button">
                                                                                    </span>
                                                                                </div>
                                                                            </SingleDatepicker>
                                                                        </div>
                                                                    </b-form-group>
                                                                </b-col>
                                                                <b-col>
                                                                    <div id="custom-timepicker" style="width: 164px;">
                                                                        <b-form-group class="ml-3">
                                                                            <label class="secondary-label align-top">Time</label>
                                                                            <b-input-group>
                                                                                <b-input-group-text slot="append">
                                                                                    <img src="../../assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                                                                                </b-input-group-text>
                                                                                <vue-timepicker v-model="scheduledTime" format="HH:mm:ss" hide-clear-button></vue-timepicker>
                                                                            </b-input-group>
                                                                        </b-form-group>
                                                                    </div>
                                                                </b-col>
                                                            </b-row>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row no-gutters>
                                                        <b-col>
                                                            <b-alert show variant="danger" class="mt-2">Your ads will run for <span class="highlighted">31</span> day(s), you’ll spend no more than <span class="highlighted">P 1,240.00</span></b-alert>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                                <b-col cols="5">
                                                    <b-card title="Health &#38; Wellness" id="ad-set-preview-wrapper">
                                                        <b-form-group id="sizeGroup"
                                                                      label="Size"
                                                                      label-for="size"
                                                                      class="secondary-label mt-4 mb-4"
                                                        >
                                                            <b-form-input id="size" v-model="form.size" disabled></b-form-input>
                                                        </b-form-group>
                                                        <b-form-group id="ageGroup"
                                                                      label="Age"
                                                                      label-for="age"
                                                                      class="secondary-label mb-4"
                                                        >
                                                            <b-form-input id="age" v-model="form.age" disabled></b-form-input>
                                                        </b-form-group>
                                                        <b-form-group id="locationGroup"
                                                                      label="Location"
                                                                      label-for="location"
                                                                      class="secondary-label"
                                                        >
                                                            <b-form-textarea id="location"
                                                                            v-model="form.location"
                                                                            :rows="3"
                                                                            :max-rows="6" disabled>
                                                            </b-form-textarea>
                                                        </b-form-group>
                                                    </b-card>
                                                </b-col>
                                            </b-row>
                                        </b-tab>
                                        <b-tab title="Ad Creative">
                                            <b-row>
                                                <b-col cols="7">
                                                    <div class="ad-creative-wrapper">
                                                        <b-tabs>
                                                            <b-tab title="Create New" active class="border">
                                                                <div class="p-4">
                                                                    <b-row no-gutters>
                                                                        <b-col cols="4">
                                                                            <h6 class="main-label">Image<i id="image-label-help" class="help d-inline-block"></i></h6>
                                                                            <b-popover target="image-label-help"
                                                                                    triggers="hover"
                                                                                    content="This is the image that will appear in the Facebook Ad.">
                                                                            </b-popover>
                                                                        </b-col>
                                                                        <b-col>
                                                                            <div id="ad-creative-upload-image" class="border" v-b-modal.adCreativeUploadImage>
                                                                                <!-- Use an if else here for showing an image -->
                                                                                <!-- <img src="../../assets/images/sample-badge.png" alt="Sample Badge"> -->
                                                                                <div class="upload-icon rounded-circle border">
                                                                                </div>
                                                                            </div>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row class="mt-2 mb-2">
                                                                        <b-col>
                                                                            <hr class="form-divider">
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row no-gutters>
                                                                        <b-col cols="4">
                                                                            <h6 class="main-label center-text-label">Message<i id="message-label-help" class="help d-inline-block"></i></h6>
                                                                            <b-popover target="message-label-help"
                                                                                    triggers="hover"
                                                                                    content="This is the written material that will appear in the Facebook Ad.">
                                                                            </b-popover>
                                                                        </b-col>
                                                                        <b-col>
                                                                            <b-form-group id="messageGroup"
                                                                                        label-for="message" class="secondary-label m-0">
                                                                                <b-form-input id="message"
                                                                                            type="text"
                                                                                            v-model="form.message"
                                                                                            required>
                                                                                </b-form-input>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row class="mt-2 mb-2">
                                                                        <b-col>
                                                                            <hr class="form-divider">
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row no-gutters>
                                                                        <b-col cols="4">
                                                                            <h6 class="main-label center-text-label">Call to Action<i id="call-to-action-label-help" class="help d-inline-block"></i></h6>
                                                                            <b-popover target="call-to-action-label-help"
                                                                                    triggers="hover"
                                                                                    content="This influences the target audience to perform a specific action.">
                                                                            </b-popover>
                                                                        </b-col>
                                                                        <b-col>
                                                                            <b-form-select id="objective"
                                                                                        v-model="form.selectedObjective" 
                                                                                        :options="form.objectiveOptions" 
                                                                                        class="mb-3 muli-sb" />
                                                                        </b-col>
                                                                    </b-row>
                                                                </div>
                                                            </b-tab>
                                                            <b-tab title="Use Existing Post" class="border">
                                                                <div class="px-4 py-3">
                                                                    <h6 class="main-label center-text-label">Select Post<i id="select-post-label-help" class="help d-inline-block"></i></h6>
                                                                    <p class="mt-2 mb-2 select-post-description">This list will automatically show posts on Facebook deems best to promote:</p>
                                                                    <b-popover target="select-post-label-help"
                                                                            triggers="hover"
                                                                            content="This is a previous Facebook Ad post that will be reposted.">
                                                                    </b-popover>
                                                                    <div class="posts-wrapper border">
                                                                        <b-table :items="posts"
                                                                                 :fields="postFields"
                                                                        >
                                                                            <template slot="imageUrl" slot-scope="data">
                                                                                <div class="image-wrapper">
                                                                                </div>
                                                                            </template>
                                                                            <template slot="id" slot-scope="data">
                                                                                <b-form-radio-group id="radios2" v-model="selected" name="radioSubComponent">
                                                                                    <b-form-radio :value="data.value" @click.stop @change="onSelectPost(data.value)"></b-form-radio>
                                                                                </b-form-radio-group>
                                                                            </template>
                                                                        </b-table>
                                                                    </div>
                                                                </div>
                                                            </b-tab>
                                                        </b-tabs>
                                                    </div>
                                                </b-col>
                                                <b-col cols="5">
                                                    <b-card title="Ad Preview" class="ad-preview-wrapper">
                                                        
                                                    </b-card>
                                                </b-col>
                                            </b-row>
                                        </b-tab>
                                    </b-tabs>
                                </div>
                                <div slot="modal-footer">
                                    <b-btn variant="outline-primary" class="mr-1" @click="tabIndex--" v-if="tabIndex === 0">
                                        Cancel
                                    </b-btn>
                                    <b-btn variant="outline-primary" class="mr-1" @click="tabIndex--" v-else>
                                        Back
                                    </b-btn>
                                    <b-btn variant="primary" class="ml-1" @click="tabIndex++">
                                        Next
                                    </b-btn>
                                </div>
                            </b-modal>
                            <b-modal id="adCreativeUploadImage" title="Upload Image">
                                <div id="ad-creative-image-upload-container" class="border mx-auto">
                                    <croppa 
                                        v-model="croppa"
                                        @new-image-drawn="onNewImage"
                                        @zoom="onZoom"
                                        :width="245"
                                        :height="128"
                                        placeholder="Choose an Image"
                                        :show-remove-button="true"
                                        :placeholder-font-size="14"
                                        remove-button-color="#ff8828">
                                    </croppa>
                                </div>
                                <div id="ad-creative-image-range-container" class="mx-auto mt-2">
                                    <input type="range" class="custom-range" id="customRange1" @input="onSliderChange" :min="sliderMin" :max="sliderMax" step=".001" v-model="sliderVal">
                                </div>
                                <div slot="modal-footer">
                                    <b-button variant="ghost" class="btn-cancel" style="margin-right: .25rem;">
                                        Cancel
                                    </b-button>
                                    <b-button variant="primary" style="margin-left: .25rem;">
                                        Save
                                    </b-button>
                                </div>
                            </b-modal>
                        </b-col>
                        <b-col>
                            <div class="filter-wrapper float-right">
                                <b-form inline>
                                    <label class="mr-sm-2 muli-b" for="inlineFormAdAccount">Facebook Page:</label>
                                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0 custom-select ml-1"
                                                    :value="1"
                                                    :options="{ '2': 'Section 9 FB', '3': 'Section 10 FB' }"
                                                    id="inlineFormAdAccount">
                                        <option slot="first" :value="1">Section 8 FB</option>
                                    </b-form-select>
                                    <b-button variant="facebook" class="ml-2">
                                        <img src="../../assets/images/icons/logout-white.svg" alt="Logout Icon">
                                        Log Out FB
                                    </b-button>
                                </b-form>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="data-container">
                                <b-table :items="items"
                                         :fields="fields"
                                         :current-page="currentPage"
                                         :per-page="perPage"
                                         responsive
                                >
                                    <template slot="publish" slot-scope="data">
                                        <switches 
                                            v-model="data.value"
                                            theme="custom"
                                            color="primary"
                                            type-bold="true"
                                            text-enabled="On"
                                            text-disabled="Off"
                                            style="top: 0px"
                                        >
                                        </switches>
                                    </template>
                                    <template slot="results" slot-scope="data">
                                        {{ data.value }}
                                        <span class="data-helper d-block">per video views</span>
                                    </template>
                                    <template slot="costPerResult" slot-scope="data">
                                        {{ data.value }}
                                        <span class="data-helper d-block">per video views</span>
                                    </template>
                                    <template slot="id" slot-scope="data">
                                        <b-row no-gutters>
                                            <b-col class="text-center">
                                                <img src="../../assets/images/actions/copy.svg" alt="Edit Button" class="action-button" @click="showModal('search-modal' + data.value)">
                                                <b-modal :id="'copy-modal' + data.value" title="Copy Modal">
                                                    <p class="my-4">Copy Modal</p>
                                                </b-modal>
                                            </b-col>
                                            <b-col class="text-center">
                                                <img src="../../assets/images/actions/edit.svg" alt="Edit Button" class="action-button" @click="showModal('edit-modal' + data.value)">
                                                <b-modal :id="'edit-modal' + data.value" title="Edit Modal">
                                                    <p class="my-4">Edit Modal</p>
                                                </b-modal>
                                            </b-col>
                                            <b-col class="text-center">
                                                <img src="../../assets/images/actions/delete.svg" alt="Delete Button" class="action-button" @click="showModal('delete-modal' + data.value)">
                                                <b-modal :id="'delete-modal' + data.value" title="Confirm Delete">
                                                    <p class="modal-main-message">Are you sure you want delete this item:</p>
                                                    <h3 class="modal-secondary-message">{{ items[data.value - 1].broadcastTitle }}</h3>
                                                    <div slot="modal-footer">
                                                        <b-btn variant="ghost" class="mr-1 btn-cancel" @click="hideModal('delete-modal' + index)">
                                                            Cancel
                                                        </b-btn>
                                                        <b-btn variant="primary" class="ml-1" @click="hideModal('delete-modal' + index)">
                                                            Yes, Delete
                                                        </b-btn>
                                                        <span class="modal-helper-message d-block mt-4">Caution: This cannot be undone.</span>
                                                    </div>
                                                </b-modal>
                                            </b-col>
                                        </b-row>
                                    </template>
                                </b-table>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Switches from "vue-switches";
import EngagementNav from "./EngagementNav.vue";
import Datepicker from "vue-bulma-datepicker";
import SingleDatepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";

const items = [
    {
        id: 1,
        publish: true,
        adName: "Test Ad",
        objective: "Video Views",
        delivery: "Not Delivering",
        results: "--",
        reach: "--",
        impressions: "--",
        costPerResult: "0.00",
        amountSpent: "P 0.00",
        ends: "September 1, 2018"
    },
    {
        id: 2,
        publish: true,
        adName: "Test Ad",
        objective: "Video Views",
        delivery: "--",
        results: "--",
        reach: "--",
        impressions: "--",
        costPerResult: "0.00",
        amountSpent: "P 0.00",
        ends: "September 1, 2018"
    },
    {
        id: 3,
        publish: true,
        adName: "Test Ad",
        objective: "Video Views",
        delivery: "Not Delivering",
        results: "--",
        reach: "--",
        impressions: "--",
        costPerResult: "0.00",
        amountSpent: "P 0.00",
        ends: "September 1, 2018"
    },
    {
        id: 4,
        publish: true,
        adName: "Test Ad",
        objective: "Video Views",
        delivery: "--",
        results: "--",
        reach: "--",
        impressions: "--",
        costPerResult: "0.00",
        amountSpent: "P 0.00",
        ends: "September 1, 2018"
    },
    {
        id: 5,
        publish: true,
        adName: "Test Ad",
        objective: "Video Views",
        delivery: "Not Delivering",
        results: "--",
        reach: "--",
        impressions: "--",
        costPerResult: "0.00",
        amountSpent: "P 0.00",
        ends: "September 1, 2018"
    },
    {
        id: 6,
        publish: true,
        adName: "Test Ad",
        objective: "Video Views",
        delivery: "--",
        results: "--",
        reach: "--",
        impressions: "--",
        costPerResult: "0.00",
        amountSpent: "P 0.00",
        ends: "September 1, 2018"
    },
    {
        id: 7,
        publish: true,
        adName: "Test Ad",
        objective: "Video Views",
        delivery: "Not Delivering",
        results: "--",
        reach: "--",
        impressions: "--",
        costPerResult: "0.00",
        amountSpent: "P 0.00",
        ends: "September 1, 2018"
    }
];

const posts = [
    { id: 1, imageUrl: "Image URL", message: "Message 1" },
    { id: 2, imageUrl: "Image URL", message: "Message 2" },
    { id: 3, imageUrl: "Image URL", message: "Message 3" },
    { id: 4, imageUrl: "Image URL", message: "Message 4" },
    { id: 5, imageUrl: "Image URL", message: "Message 5" },
    { id: 6, imageUrl: "Image URL", message: "Message 6" },
    { id: 7, imageUrl: "Image URL", message: "Message 7" },
    { id: 8, imageUrl: "Image URL", message: "Message 8" },
    { id: 9, imageUrl: "Image URL", message: "Message 9" }
];

export default {
    name: "facebook-ads",
    data() {
        return {
            form: {
                selectedObjective: "1",
                objectiveOptions: [
                    { value: 1, text: "Objective 1" },
                    { value: 2, text: "Objective 2" }
                ],
                adName: "",
                selectedCategory: "1",
                categoryOptions: [
                    { value: 1, text: "Health and Wellness" },
                    { value: 2, text: "Category 2" }
                ],
                size: "23,000",
                age: "20 - 60",
                location: "Philippines: Davao City"
            },
            daterangeConfig: {
                altInput: true,
                altFormat: "M j, Y",
                dateFormat: "Y-m-d",
                static: true,
                mode: "range",
                defaultDate: ["today", "today"]
                // onChange: function(selectedDates, dateStr) {
                //     console.log(selectedDates, dateStr);
                // }
            },
            items: items,
            fields: [
                { key: "publish", sortable: true },
                { key: "adName", sortable: true },
                { key: "objective", sortable: true },
                { key: "delivery", sortable: true },
                { key: "results", sortable: true },
                { key: "reach", sortable: true },
                { key: "impressions", sortable: true },
                { key: "costPerResult", sortable: true },
                { key: "amountSpent", sortable: true },
                { key: "results", sortable: true },
                { key: "id", label: "Action" }
            ],
            currentPage: 1,
            perPage: 5,
            totalRows: items.length,
            tabIndex: 0,
            scheduledTime: {
                HH: "10",
                mm: "00",
                ss: "00"
            },
            croppa: {},
            sliderVal: 0,
            sliderMin: 0,
            sliderMax: 0,
            posts: posts,
            postFields: [
                { key: "imageUrl", label: "Image" },
                { key: "message", label: "Message" },
                { key: "id", label: "Checkbox" }
            ],
            selected: null
        };
    },
    components: {
        EngagementNav,
        Switches,
        Datepicker,
        VueEditor,
        SingleDatepicker,
        VueTimepicker
    },
    methods: {
        hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
        },
        showModal(modal) {
            this.$root.$emit("bv::show::modal", modal);
        },
        openPicker() {
            this.$refs.programaticOpen.showCalendar();
        },
        onNewImage() {
            this.sliderVal = this.croppa.scaleRatio;
            this.sliderMin = this.croppa.scaleRatio / 2;
            this.sliderMax = this.croppa.scaleRatio * 2;
        },
        onSliderChange(evt) {
            var increment = evt.target.value;
            this.croppa.scaleRatio = +increment;
        },
        onZoom() {
            this.sliderVal = this.croppa.scaleRatio;
        },
        onSelectPost(record) {
            for (var i = 0; i < this.posts.length; i++) {
                this.posts[i]._rowVariant = "";
            }
            posts[record - 1]._rowVariant = "selected";
        }
    }
};
</script>

<style lang="scss">
</style>
